import { axiosAPI } from 'utils';

export default { 
  getOnePersonByFamily(familyId) {
    return axiosAPI
      .get(`api/users/${familyId}/one-person-by-family`)
      .then((res) => res.data)
      .catch((err) => err.response.data);
  },
  getOnePersonByParams(params) {
    return axiosAPI
      .get(`api/users/one-person-by-params`, { params })
      .then((res) => res.data)
      .catch((err) => err.response.data);
  },
}
